import React from 'react'

// Icon registry — keyed by the `icon` string stored per Service / PortalFeature.
// Adding a new option in the DB just needs a matching entry here.
const s = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
};

export const ICONS = {
    crown: (
        <svg viewBox="0 0 24 24" {...s}>
            <path d="M5 8c0-1.7.8-3 2-3.5L9 4l2 2 1-2 1 2 2-2 2 .5C18.2 5 19 6.3 19 8v2c0 2.5-1.5 6-3.5 7.5H8.5C6.5 16 5 12.5 5 10V8z" />
            <path d="M9 4v4M12 4v4M15 4v4" />
        </svg>
    ),
    implant: (
        <svg viewBox="0 0 24 24" {...s}>
            <line x1="12" y1="2" x2="12" y2="22" />
            <path d="M8 6h8M7 10h10M8 14h8M9 18h6" />
        </svg>
    ),
    veneer: (
        <svg viewBox="0 0 24 24" {...s}>
            <path d="M12 3C7 3 3 7 3 12c0 4 2.5 7.4 6 8.7V21h6v-.3c3.5-1.3 6-4.7 6-8.7 0-5-4-9-9-9z" />
            <path d="M9 12c0 1.7 1.3 3 3 3s3-1.3 3-3" />
        </svg>
    ),
    denture: (
        <svg viewBox="0 0 24 24" {...s}>
            <path d="M4 12c0-4 2-7 4-7s3 2 4 2 2-2 4-2 4 3 4 7-2 7-4 7-3-2-4-2-2 2-4 2-4-3-4-7z" />
            <path d="M8 10v2M12 9v3M16 10v2" />
        </svg>
    ),
    nightguard: (
        <svg viewBox="0 0 24 24" {...s}>
            <path d="M3 12c0-5 2-8 4-8s3 3 5 3 3-3 5-3 4 3 4 8-2 8-4 8-3-3-5-3-3 3-5 3-4-3-4-8z" />
            <path d="M3 12h18" />
        </svg>
    ),
    printer: (
        <svg viewBox="0 0 24 24" {...s}>
            <polyline points="6 9 6 2 18 2 18 9" />
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" rx="1" />
        </svg>
    ),
    upload: (
        <svg viewBox="0 0 24 24" {...s} strokeWidth={1.8}>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
    ),
    clock: (
        <svg viewBox="0 0 24 24" {...s} strokeWidth={1.8}>
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    invoice: (
        <svg viewBox="0 0 24 24" {...s} strokeWidth={1.8}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <line x1="10" y1="9" x2="8" y2="9" />
        </svg>
    ),
    pin: (
        <svg viewBox="0 0 24 24" {...s} strokeWidth={1.8}>
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            <circle cx="12" cy="9" r="2.5" />
        </svg>
    ),
    phone: (
        <svg viewBox="0 0 24 24" {...s} strokeWidth={1.8}>
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 12 19.79 19.79 0 0 1 1 3.18 2 2 0 0 1 2.96 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16v.92z" />
        </svg>
    ),
    arrow: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
};

const Icon = ({ name }) => {
    return <>{ICONS[name] ?? ICONS.crown}</>;
};

export default Icon;
